/*** IMPORTS FROM imports-loader ***/
var define = false;

import { parallax } from './parallax';
var Flickity = require('flickity');
require('flickity-as-nav-for');
require('flickity-imagesloaded');
require('flickity-fade');

export function featuredTipsSlider() {

  if (window.innerWidth < 960) {
    var featuredTipsSlider = document.querySelector('.featuredTips__slider');
    var flkty = new Flickity(featuredTipsSlider, {
      // options
      cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: true,
      autoPlay: false,
      pageDots: false,
      dragThreshold: 1,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 1000);
          // setTimeout(() => {
          //   flkty.next();
          // }, 2000);
        }
      }
    });

    // Parallax Effect
    var imgs = featuredTipsSlider.querySelectorAll('.featuredTips__slideImage');
    // get transform property
    var docStyle = document.documentElement.style;
    var transformProp = typeof docStyle.transform == 'string' ?
      'transform' : 'WebkitTransform';

    flkty.on('scroll', function () {
      // flkty.slides.forEach(function (slide, i) {
      //   var img = imgs[i];
      //   var x = (slide.target + flkty.x) * -1 / 2;
      //   img.style[transformProp] = 'translateX(' + x + 'px)';
      // });

      flkty.slides.forEach( function( slide, i ) {
        var img = imgs[i],
          x   = 0;

          if( 0 === i ) {
            x = Math.abs( flkty.x ) > flkty.slidesWidth ? ( flkty.slidesWidth + flkty.x + flkty.slides[flkty.slides.length - 1 ].outerWidth + slide.target ) : ( slide.target + flkty.x );
          } else if( i === flkty.slides.length - 1 ) {
            x = Math.abs( flkty.x ) + flkty.slides[i].outerWidth < flkty.slidesWidth ? ( slide.target - flkty.slidesWidth + flkty.x - flkty.slides[i].outerWidth ) : ( slide.target + flkty.x );
          } else {
            x = slide.target + flkty.x;
          }
        img.style[ transformProp ] = 'translateX(' + x * ( -1.5 ) + 'px)';
      });
    });
  } else {
    var featuredTipsSlider = document.querySelector('.featuredTips__slider');
    var flkty = new Flickity(featuredTipsSlider, {
      // options
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: false,
      prevNextButtons: true,
      // autoPlay: 6000,
      pageDots: false,
      fade: true,
      draggable: false,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 1000);
          // setTimeout(() => {
          //   flkty.next();
          // }, 2000);
        }
      }
    });
  }

  var tapArea, startX ;
    tapArea = document.querySelectorAll('.featuredTips__slider');
    startX = 0;
    for (var item of tapArea) {
      item.ontouchstart = function(e) {
          startX = e.touches[0].clientX;
      };
      item.ontouchmove = function(e) {
          if (Math.abs(e.touches[0].clientX - startX) > 5 && e.cancelable ) {
              e.preventDefault();
          }
      };
  }

  // Counter/Status
  // var carouselStatus = document.querySelector('.featuredRecipes__status');
  // var flkty = Flickity.data(featuredRecipesSlider);

  // function updateStatus() {
  //   var cellNumber = flkty.selectedIndex + 1;
  //   carouselStatus.innerHTML = '0' + cellNumber + '/' + '0' + flkty.slides.length;
  // }
  // updateStatus();
  // flkty.on('change', updateStatus);



  // Slider Nav
  var featuredTipsSliderNav = document.querySelector('.featuredTips__sliderNav');
  var flkty = new Flickity(featuredTipsSliderNav, {
    // options
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    asNavFor: '.featuredTips__slider',
    adaptiveHeight: true,
    prevNextButtons: false,
    pageDots: true,
    wrapAround: true,
    on: {
      ready: function () {
        setTimeout(() => {
          flkty.resize();
        }, 1000);
      }
    }
  });

}
